import React, { useState, useEffect, useRef } from "react";
import ScrollArea from "react-scrollbar";
import cm from "classnames";
import shevron from "../../../../style/icons/ShevronDown/shevron-down.svg";
import close from "../../../../style/icons/CloseInGreyCircle/close.svg";
import './simpleSelect.scss';
import "../formComponents.scss";

const SimpleSelect = ({
  options = [],
  defaultValue,
  placeholder,
  setSelectedValue,
  errorRequire,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);
  const [isRequire, setIsRequire] = useState(false);
  const [touched, setTouched] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if(setSelectedValue) return
    inputRef.current.value = ''
  }, [options])

  const handleReset = () => {
    setIsActive(false);
    inputRef.current.value = '';
  }

  useEffect(()=> {
    if (defaultValue) {
      inputRef.current.value = defaultValue;
    }
  }, [defaultValue]);

  const clearSelected = ()=> {
    inputRef.current.value = '';
    setIsActive(true);
    handleBlur();
  }

  const toggleState = () => {
    setIsActive(!isActive)
  }
  
  const handleChange = (value) => {
    inputRef.current.value = value;
    if(setSelectedValue) setSelectedValue(value)
    setIsActive(false);
    
    if (value && isRequire) {
      setIsRequire(false);
    }
  };

  const openList = () => setIsActive(!isActive);
  const toggleActive = isActive => !isActive;
  const selected = inputRef.current && inputRef.current.value.toString();
  const labelValue = selected
    ? options.find(_ => _.value.toString() === selected) && options.find(_ => _.value.toString() === selected).label
    : '';

  const handleBlur = () => {
    if (!touched) {
      setTouched(true);
    }
    
    if (rest.required && !selected) {
      setIsRequire(true);
    }
  };

  const handleFocus = () => {
    if (isRequire) {
      setIsRequire(false);
    }
  };

  const requireClasseName = isRequire && touched ? 'errorRequire show' : 'errorRequire';

  return (
    <div className="formField">
      <div className="fieldSimpleSelect">
        {errorRequire && (
          <label className={requireClasseName}>{errorRequire}</label>
        )}
        <div onClick={openList} onBlur={handleBlur} onFocus={handleFocus}>
        <input
          className="simpleInput"
          type="input"
          style={{pointerEvents: "none"}}
          placeholder={placeholder}
          onChange={handleChange}
          onReset={handleReset}
          ref={inputRef}
          {...rest}
        />
        {labelValue && <div className="value">
          {labelValue}
          </div>}
        </div>
        {selected?
          <img
            className="circle"
            src={close}
            alt=""
            onClick={clearSelected}
          /> :
          <img
            className={`shevron ${isActive ? "active" : ""}`}
            src={shevron}
            alt=""
            onClick={toggleActive}
          />
        }
        <div className={"wrapperOptions"}>
          {isActive && (
            <ScrollArea speed={0.1} className={"area"} horizontal={false}>
              <div className={"options"}>
                {options.map((option, index) => (
                  <div
                    key={index}
                    className={cm("option", {
                      active: option.value === selected,
                    })}
                    onClick={() => handleChange(option.value)}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            </ScrollArea>
          )}
        </div>
      </div>
    </div>
  );
};
export default SimpleSelect;
